<template>
    <div class="customerdetails">
        <div class="right">
            <div class="customerdetailsHead">
                <div class="backCustomerList" @click="backClick" style="cursor: pointer">
                    <span><i class="el-icon-arrow-left"></i>
                    </span>
                    <span class="backCustomerText" style="cursor: pointer" v-if="this.$route.query.customerUrl==='customerdetails'">返回客户列表</span>
                    <span class="backCustomerText" style="cursor: pointer" v-if="this.$route.query.url==='customerdetails'">返回公司详情</span>
                </div>
                <div class="customerdetailHead">
                    <div class="customerdetailText">
                        <!--客户详情-->
                    </div>
                    <div class="detailHeadBtn" >
                        <el-button size="small"  @click="addWorkOrder" style="font-size: 13px">新增工单</el-button>
                        <el-button size="small" @click="shareClick"
                                    v-clipboard:copy="copyUrl"
                                    v-clipboard:success="onCopy" style=" border: none;
                                                                          border-radius: 0px;
                                                                          margin-left: 0px;
                                                                          font-size: 13px;
                                                                          border-right: 1px solid #DCDFE6;
                                                                          border-top: 1px solid #DCDFE6;
                                                                          border-bottom: 1px solid #DCDFE6;">分享</el-button>
                        <el-button size="small" @click="editClient"  style=" border: none;
                                                                              border-radius: 0px;
                                                                              margin-left: 0px;
                                                                              font-size: 13px;
                                                                              border-right: 1px solid #DCDFE6;
                                                                              border-top: 1px solid #DCDFE6;
                                                                              border-bottom: 1px solid #DCDFE6;">编辑</el-button>
                        <el-button size="small" @click="dialogVisible=true"  style=" border: none;
                                                                                      border-radius: 0px;
                                                                                      margin-left: 0px;
                                                                                      font-size: 13px;
                                                                                      border-right: 1px solid #DCDFE6;
                                                                                      border-top: 1px solid #DCDFE6;
                                                                                      border-bottom: 1px solid #DCDFE6;">删除</el-button>



                        <el-dialog title="编辑客户"  :visible.sync="dialogFormVisible" custom-class="customerListDialog" style="text-align: left" :close-on-click-modal="false">
                        <div class="flexClass">

                            <div class="flexClass1"><span class="keyred">*</span>客户名称</div>
                            <div class="flexClass2">
                                <el-input
                                        placeholder="请输入客户名称"
                                        v-model="clientName"
                                        clearable
                                >
                                </el-input>
                            </div>
                        </div>
                        <div class="flexClass">
                            <div class="flexClass1">
                                等级
                            </div>
                            <div class="flexClass2">
                                <el-radio v-model="levelRadio" label="1">普通</el-radio>
                                <el-radio v-model="levelRadio" label="2">vip</el-radio>
                            </div>
                        </div>
                        <div class="flexClass">
                            <div class="flexClass1">电话</div>
                            <div class="flexClass2" >
                                <el-input
                                        placeholder="请输入电话"
                                        v-model="inputPhone"
                                        clearable
                                        @blur="phoneClick"
                                >
                                </el-input>
                            </div>
                        </div>
                        <div class="flexClass">
                            <div class="flexClass1">邮箱</div>
                            <div class="flexClass2" >
                                <el-input
                                        placeholder="请输入邮箱"
                                        v-model="inputEmail"
                                        clearable
                                        @blur="emailClick"
                                >
                                </el-input>
                            </div>
                        </div>
                        <div class="flexClass">
                            <div class="flexClass1">公司</div>
                            <div class="flexClass2" >
                                <el-select v-model="companyValue"
                                           clearable
                                           placeholder="请选择或者搜索公司名称"
                                           style="width: 100%;position: relative"
                                           v-loadmore="loadMore"
                                >
                                    <div style="margin: 5px 0">
                                        <el-input
                                                placeholder="可搜索"
                                                v-model="companySelect"
                                                clearable
                                                style="position: absolute;top: 0;z-index: 9"
                                                @input="changeSelectCompany"

                                        >
                                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                        </el-input>
                                    </div>
                                    <div v-if="selectCompanyList.length===0">
                                        <el-option value="" style="height: 10px"></el-option>
                                    </div>
                                    <div style="margin-top: 32px;margin-bottom: 32px">
                                        <el-option
                                                v-for="item in selectCompanyList"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </div>

                                    <div
                                            style="background-color: #409EFF;text-align: center;height: 32px;line-height: 32px;cursor: pointer;width: 100%;position: absolute;bottom: 0"
                                            @click="dialogFormVisible1=true"
                                            :class="{isNullOption:selectCompanyList.length===0}"
                                    >
                                        <span style="color: white">新建公司</span>
                                    </div>
                                </el-select>
                            </div>
                        </div>
                        <div class="flexClass">
                            <div class="flexClass1">负责组</div>
                            <div class="flexClass2" >
                                <el-select
                                        v-model="groupValue"
                                        clearable
                                        placeholder="请选择或者搜索负责组"
                                        style="width: 100%;position: relative"
                                        @change="getAccountPerson"
                                >
                                    <div style="margin: 5px 0">
                                        <el-input
                                                placeholder="可搜索"
                                                v-model="groupSelect"
                                                clearable
                                                style="position: absolute;top: 0;z-index: 9"
                                                @input="changeSelectGroup"
                                        >
                                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                        </el-input>
                                    </div>
                                    <div v-if="selectGroupList.length===0">
                                        <el-option value="" style="height: 5px"></el-option>
                                    </div>
                                    <div style="margin-top: 32px">
                                        <el-option
                                                v-for="item in selectGroupList"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </div>

                                </el-select>
                            </div>
                        </div>
                        <div class="flexClass">
                            <div class="flexClass1">负责人</div>
                            <div class="flexClass2" >
                                <el-select v-model="personValue" clearable  placeholder="请选择或者搜索负责人" style="width: 100%;position: relative">
                                    <div style="margin: 5px 0">
                                        <el-input
                                                placeholder="可搜索"
                                                v-model="personSelect"
                                                clearable
                                                style="position: absolute;top: 0;z-index: 9"
                                                @input="changeSelectPerson"
                                        >
                                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                        </el-input>
                                    </div>
                                    <div v-if="selectPersonList.length===0">
                                        <el-option value="" style="height: 5px;"></el-option>
                                    </div>
                                    <div style="margin-top: 32px">
                                        <el-option
                                                v-for="item in selectPersonList"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </div>

                                </el-select>
                            </div>
                        </div>
                        <div class="flexClass">
                            <div class="flexClass1">描述</div>
                            <div class="flexClass2">
                                <el-input
                                        type="textarea"
                                        :rows="2"
                                        placeholder="对该客户的描述"
                                        v-model="describe">
                                </el-input>
                            </div>
                        </div>

                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogFormVisible = false">取 消</el-button>
                            <el-button type="primary" @click="modifyClientClick">保存</el-button>
                        </div>
                    </el-dialog>

                        <el-dialog
                                title="删除客户"
                                :visible.sync="dialogVisible"
                                custom-class="customerInfoItemDialog"
                                style="text-align: left"
                                :close-on-click-modal="false"

                        >
                            <div class="deleteText">
                                <div class="isDelete"> 是否删除该客户？</div>
                                <div class="promptText">删除客户后，不会影响该已有工单</div>
                            </div>

                            <span slot="footer" class="dialog-footer">
                            <el-button @click="dialogVisible = false">取 消</el-button>
                            <el-button  @click="deleteClientInfo" style="background-color: red;color: white">删 除</el-button>
                          </span>
                        </el-dialog>

                    </div>
                </div>

            </div>
            <div class="customerdetailContain">
                <div class="customerNamelInfo">
                    <div class="nameInfo">
                        <div class="customerNameInfoText">{{clientDetail.name}}</div>
                        <div class="detailNameBtn">
                            <button v-if="clientDetail.grade==='NORMAL'" class="levelBtn">普通</button>
                            <button v-if="clientDetail.grade==='VIP'" class="levelVIPBtn">VIP</button>
                        </div>
                    </div>
                    <div class="detailPhone" >
                        <div class="phoneText">电话:</div>
                        <div class="phoneNum" v-if="clientDetail.tel!==''">{{clientDetail.tel}}</div>
                        <div class="phoneNum" v-if="clientDetail.tel===''">--</div>
                    </div>
                    <div class="detailEmail" >
                        <div class="emailAddressText">邮箱:</div>
                        <div class="emailAddressNum emailCompanyNum1" v-if="clientDetail.mail!==''">{{clientDetail.mail}}</div>
                        <div class="emailAddressNum" v-if="clientDetail.mail===''">--</div>
                    </div>
                    <div class="detailCompany" >
                        <div class="emailCompanyText">公司:</div>
                        <div class="emailCompanyNum emailCompanyNum1" v-if="clientDetail.company">{{clientDetail.company.name}}</div>
                        <div class="emailCompanyNum emailCompanyNum1" v-if="clientDetail.companyId===''">--</div>
                    </div>
                    <div class="detailResGroup">
                        <div class="detailResGroupText">负责组:</div>
                        <div class="detailResGroupNum"  v-if="clientDetail.group&&clientDetail.groupId">{{clientDetail.group.name}}</div>
                        <div class="detailResGroupNum"  v-if="clientDetail.groupId===''">--</div>
                    </div>
                    <div class="detailResPerson" >
                        <div class="detailResPersonText">负责人:</div>
                        <div class="detailResPersonNum" v-if="clientDetail.principal&&clientDetail.principalId">{{clientDetail.principal.name}}</div>
                        <div class="detailResPersonNum" v-if="clientDetail.principalId===''">--</div>
                    </div>
                    <div class="detailDescribe">
                        <div class="detailDescribeText">描述:</div>
                        <div class="detailDescribeCon">
                            <el-input
                                    type="textarea"
                                    :rows="2"
                                    placeholder="请输入描述内容"
                                    v-model="decCon"
                                    @blur="modifyClientDesc"
                                    >
                            </el-input>
                        </div>
                    </div>
                    <div class="fengexian"></div>
                    <div class="customerAddTime">
                        <div class="AddTimeText">添加时间:</div>
                        <div class="AddTime">{{dateFormat(clientDetail.createTime)}}</div>
                    </div>
                    <div class="customerUpdateTime">
                        <div class="updateTimeText">更新时间:</div>
                        <div class="updateTime">{{dateFormat(clientDetail.updateTime)}}</div>
                    </div>
                </div>
                <div class="customerDetailInfo" v-if="rightShow===1">
                  <div class="detailInfoTitle">
                      <span>联络记录</span>
                  </div>
                    <div style="height: calc(100vh - 205px);overflow-y: scroll;overflow-x: hidden;">
                        <div class="detailInfoContain" v-for="item in workOrderList" :key="item.id">
                            <div class="customerOrder">
                                <div class="orderText">工单</div>
                                <div class="orderTime">{{dateFormat(item.updateTime)}}</div>
                            </div>
                            <div class="workOrderTheme">
                                <div class="orderThemeTitle">主题</div>
                                <div class="orderThemeCon">{{item.name}}</div>
                                <div class="lookDetail" @click="lookDetailClick(item.id)">查看详情</div>
                            </div>
                            <div class="workOrderDescribe">
                                <div class="orderDescribeTitle">描述</div>
                                <div class="orderDescribeCon" v-html="item.description"></div>
                            </div>
                            <div class="workOrderStatus">
                                <div class="orderStatusTitle">状态</div>
                                <div class="orderStatusBtn">
                                    <button class="detailStatus statusBlue" v-if="item.status.color==='blue'">{{item.status.name}}</button>
                                    <button class="detailStatus statusYellow" v-if="item.status.color==='yellow'">{{item.status.name}}</button>
                                    <button class="detailStatus statusGreen" v-if="item.status.color==='green'">{{item.status.name}}</button>
                                    <button class="detailStatus statusOrange" v-if="item.status.color==='orange'">{{item.status.name}}</button>
                                    <button class="detailStatus statusBluePurple" v-if="item.status.color==='bluePurple'">{{item.status.name}}</button>
                                    <button class="detailStatus statusDarkGrey" v-if="item.status.color==='darkGrey'">{{item.status.name}}</button>
                                    <button class="detailStatus statusGrey" v-if="item.status.color==='grey'">{{item.status.name}}</button>
                                    <button class="detailStatus statusBrown" v-if="item.status.color==='brown'">{{item.status.name}}</button>
                                    <button class="detailStatus statusRed" v-if="item.status.color==='red'">{{item.status.name}}</button>
                                    <button class="detailStatus statusRedPurple" v-if="item.status.color==='redPurple'">{{item.status.name}}</button>
                                    <button class="detailStatus statusBlack" v-if="item.status.color==='black'">{{item.status.name}}</button>
                                </div>
                            </div>
                            <div class="workOrderPriority">
                                <div class="orderPriorityTitle">优先级</div>
                                <div class="orderPriorityCon">{{item.priority|priorityType}}</div>
                            </div>
                            <div class="workOrderAcceGroup" >
                                <div class="orderAcceGroupTitle">受理组</div>
                                <div class="orderAcceGroupCon" v-if="item.assigneeGroupId&&item.assigneeGroup">{{item.assigneeGroup.name}}</div>
                                <div class="orderAcceGroupCon" v-else>--</div>
                            </div>
                            <div class="workOrderAccePerson" >
                                <div class="orderAccePersonTitle">受理人</div>
                                <div class="orderAccePersonCon" v-if="item.assigneeId&&item.assignee">{{item.assignee.name}}</div>
                                <div class="orderAccePersonCon" v-else>--</div>
                            </div>
                            <div class="orderCreatePerson">
                                <div class="orderCreatePersonTitle">创建人</div>
                                <div class="orderCreatePersonCon" v-if="item.creator!==null">{{item.creator.name}}</div>
                                <div class="orderCreatePersonCon" v-if="item.creator===null">--</div>
                            </div>
                            <div class="split"></div>
                            <!-- <div class="IM">
                                 <div class="IMtext">IM</div>
                                 <div class="IMtime">2020-08-03</div>
                             </div>
                             <div class="customerService">
                                 <div class="customerServiceText">受理客服</div>
                                 <div class="ServiceNumName">我是账号姓名</div>
                             </div>-->
                        </div>
                    </div>

                </div>
                <div class="customerDetailInfo1" v-if="rightShow===0">
                    <div style="position: absolute;left: 50%;top: 50%;font-size: 18px">暂无联络记录</div>
                </div>
            </div>
        </div>

        <el-dialog title="新增公司"  :visible.sync="dialogFormVisible1" custom-class="customerListDialog" style="text-align: left" :close-on-click-modal="false">
            <div class="companyFlexClass">
                <div class="companyFlexClass1"><span class="keyred">*</span>公司名称</div>
                <div class="companyFlexClass2">
                    <el-input
                            placeholder="请输入公司名称"
                            v-model="companyName"
                            clearable
                    >
                    </el-input>
                </div>
            </div>
            <div class="companyFlexClass">
                <div class="companyFlexClass1">
                    等级
                </div>
                <div class="companyFlexClass2">
                    <el-radio v-model="levelRadio" label="1">普通</el-radio>
                    <el-radio v-model="levelRadio" label="2">vip</el-radio>
                </div>
            </div>
            <div class="companyFlexClass">
                <div class="companyFlexClass1">公司邮箱后缀
                    <el-popover
                            placement="top-start"
                            width="230"
                            trigger="hover"
                    >
                        <span style="color: #F56C6C">客户主邮箱的后缀是企业邮箱后缀时，将被自动添加到该公司</span>

                        <span slot="reference" style="margin-left: 4px;height: 20px;text-align: center">
                                       <i class="el-icon-warning-outline" style="font-size: 14px;color: #AAAAAA"></i>
                                    </span>
                    </el-popover>
                </div>
                <div class="companyFlexClass2" >
                    <el-input
                            placeholder="请输入公司邮箱后缀"
                            v-model="emailSuffix"
                            clearable
                    >
                    </el-input>
                </div>
            </div>
            <div class="companyFlexClass">
                <div class="companyFlexClass1">公司联系人</div>
                <div class="companyFlexClass2" >
                    <el-input
                            placeholder="请输入公司联系人姓名"
                            v-model="contactPerson"
                            clearable
                    >
                    </el-input>
                </div>
            </div>
            <div class="companyFlexClass">
                <div class="companyFlexClass1">联系人电话</div>
                <div class="companyFlexClass2" >
                    <el-input
                            placeholder="请输入公司联系人电话"
                            v-model="contactPersonTel"
                            clearable
                            @blur="phoneBlurClick"
                    >
                    </el-input>
                </div>
            </div>
            <div class="companyFlexClass">
                <div class="companyFlexClass1">联系人邮箱</div>
                <div class="companyFlexClass2" >
                    <el-input
                            placeholder="请输入联系人邮箱"
                            v-model="contactPersonMail"
                            clearable
                            @blur="emaiBblurClick"
                    >
                    </el-input>
                </div>
            </div>
            <div class="companyFlexClass">
                <div class="companyFlexClass1">负责组</div>
                <div class="companyFlexClass2" >
                    <el-select v-model="companyGroupValue"
                               clearable
                               filterable
                               placeholder="请选择或者搜索负责组"
                               style="width: 100%;position: relative"
                               @change="getCompanyAccountPerson"
                    >
                        <div>
                            <el-input
                                    placeholder="可搜索"
                                    v-model="groupSelect"
                                    clearable
                                    style="position: absolute;top: 0;z-index: 9"
                                    @input="changeCompanySelectGroup"
                            >
                            </el-input>
                        </div>
                        <div v-if="selectCompanyGroupList.length===0">
                            <el-option value="" style="height: 40px"></el-option>
                        </div>
                        <div style="margin-top: 32px" v-if="selectCompanyGroupList.length >0">
                            <el-option
                                    v-for="item in selectCompanyGroupList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                            >
                            </el-option>
                        </div>

                    </el-select>
                </div>
            </div>
            <div class="companyFlexClass">
                <div class="companyFlexClass1">负责人</div>
                <div class="companyFlexClass2" >
                    <el-select v-model="companyPersonValue"
                               clearable
                               filterable
                               placeholder="请选择或者搜索负责人"
                               style="width: 100%;position: relative"
                    >
                        <div>
                            <el-input
                                    placeholder="可搜索"
                                    v-model="personSelect"
                                    clearable
                                    style="position: absolute;top: 0;z-index: 9"
                                    @input="changeCompanySelectPerson"
                            >
                            </el-input>
                        </div>
                        <div v-if="selectCompanyPersonList.length === 0">
                            <el-option value="" style="height: 40px"></el-option>
                        </div>
                        <div style="margin-top: 32px" v-if="selectCompanyPersonList.length > 0">
                            <el-option
                                    v-for="item in selectCompanyPersonList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </div>
                    </el-select>
                </div>
            </div>
            <div style="display: flex;padding: 6px 0">
                <div style="flex: 0.2 0.2 0;height:40px;line-height: 40px">描述</div>
                <div style="flex: 0.8 0.8 0;">
                    <el-input
                            type="textarea"
                            :rows="2"
                            placeholder="对该公司的描述"
                            v-model="description">
                    </el-input>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="calcAddCompany">取 消</el-button>
                <el-button type="primary" @click="addClientCompany">保存</el-button>
                <el-button type="primary" @click="addCompanyContinue">保存并继续新增</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    export default {
        name: "CustomerDetails",
        data(){
            return{
                dialogFormVisible1:false,
                clientName:'',
                levelRadio:'1',
                inputPhone:'',
                inputEmail:'',
                companyValue:'',
                companySelect:'',
                groupValue:'',
                groupSelect:'',
                personValue:'',
                personSelect:'',
                describe:'',
                customerInfoItem:[],
                decCon:'',
                dialogFormVisible:false,
                dialogVisible:false,
                pageSize:10,
                currentPage:1,
                clientDetail:{},
                company:{
                    list:[]
                },
                accountGroup:{
                    list:[]
                },
                clientGroupName:'',
                accountGroupPerson:{
                    list:[]
                },
                personName:'',
                grade:'',
                accountPerson:{
                    list:[]
                },
                clientWorkOrder:[],
                workOrderGroup:'',
                clientList:[],
                rightShow:0,
                companyName:'',
                emailSuffix:'',
                contactPerson:'',
                contactPersonMail:'',
                contactPersonTel:'',
                description:'',
                companyNum:0,
                groups:[],
                persons:[],
                fileList:[],
                companyPersonValue:'',
                companyGroupValue:'',
                workOrderPerson:'',
                workOrderList:[],
                copyUrl:'',
                CompanyPageSize:10000,
                selectCompanyList:[],
                selectGroupList:[],
                selectCompanyGroupList:[],
                selectPersonList:[],
                selectCompanyPersonList:[],
                clientPageSize:1000,
                checkGrade:'',
                addCompanySuccess:false,
                orderPageSize:1000,
                orderCurrentPage:1

            }
        },
        mounted() {
            this.getCustomerDetail()
            this.getCompany()
            this.getAccountGroup()
            this.getWorkOrder()
            this.getAccountPerson()
            this.getCompanyAccountPerson()
            /*this.getWorkOrderAccountPerson()*/

        },
        filters:{
            priorityType(value){
                if(value==='LOW')
                    return '低'
                if(value==='HIGH')
                    return '高'
                if(value==='URGENT')
                    return '紧急'
                if(value==='MIDDLE')
                    return '中'
            }
        },
        methods:{

            backClick(){
                this.$router.back()
            },
            lookDetailClick(orderId){
                this.$router.push({
                    path:'editworkorder',
                    query:{
                        id:orderId,
                        url:'customerDetail'
                    }
                })
            },
            addWorkOrder(){
                this.$router.push({
                    path:'/addworkorder',
                    query:{
                        url:'customerDetail'
                    }
                })
            },

            deleteClientInfo(){
                this.$http.delete('/api/client/'+this.$route.query.id).then(res=>{
                    if(res.data.code==='0'){
                        this.$message.success('删除客户信息成功')
                    }
                })
                this.dialogVisible=false
                this.$router.back()
            },
            modifyClientClick(){
                if(this.levelRadio==='1'){
                    this.grade='NORMAL'
                }
                if(this.levelRadio==='2'){
                    this.grade='VIP'
                }
                if(this.clientName!=='')
                {
                    this.$http.put('/api/client/'+this.$route.query.id,{
                        updateTime:new Date(),
                        name:this.clientName,
                        grade:this.grade,
                        tel:this.inputPhone,
                        mail:this.inputEmail,
                        groupId: this.groupValue,
                        principalId: this.personValue,
                        companyId: this.companyValue,
                        company:this.companyName,
                        source: "ADD_MANULLY",
                        description: this.describe
                    }).then(res=>{
                        if(res.data.code==='0'){
                            this.$message.success('修改用户信息成功')
                        }
                        this.getCustomerDetail()
                        this.getAccountGroup()
                        this.$emit('modifyClientClick')
                    })
                    this.dialogFormVisible=false
                }
                else
                    this.$message('请输入客户名称')

            },
            modifyClientDesc(){
                let clientData=this.clientDetail;
                clientData.description=this.decCon;
                this.$http.put('/api/client/'+this.$route.query.id,clientData)
                    .then(res=>{
                        if(res.data.code==='0'){
                            this.$message.success('修改用户信息成功')
                        }
                    })
            },
            //获取用户的详情信息
            getCustomerDetail(){
                this.$http.get('/api/client/page?num='+this.clientPageSize+'&page='+this.currentPage)
                    .then(response => {
                        this.clientList = response.data.data.content;
                        console.log(this.clientList)
                        this.clientList.forEach(item=>{
                            if(item.id===this.$route.query.id)
                            {
                                this.clientDetail=item
                                console.log(this.clientDetail)
                                this.decCon=this.clientDetail.description
                            }

                        })
                        console.log(this.clientList)
                        console.debug('FieldApiExample field page:', this.clientList);
                    })
            },
            //获取全部的公司
            getCompany(){
              this.$http.get('/api/client-company/page?num='+this.CompanyPageSize+'&page'+this.currentPage).then(res=>{
                  this.company.list=res.data.data.content
                  this.selectCompanyList=res.data.data.content
                  this.company.list.find(item=>{
                      if(this.clientDetail.companyId===item.id)
                      {
                          this.companyValue=item.id
                          this.getCustomerDetail()
                          this.getAccountGroup()
                      }

                  })
                  if(this.addCompanySuccess===true)
                  {

                      let length=this.company.list.length
                      this.companyValue=this.company.list[length-1].id
                      console.log(this.company.list[length-1].id)
                  }

              })
            },
            //获取全部的负责组
            getAccountGroup(){
                this.$http.get('/api/account/group').then(res=>{
                    this.accountGroup.list=res.data.data
                    this.selectGroupList=res.data.data
                    this.selectCompanyGroupList=res.data.data
                    this.selectGroupList.find(item=>{
                        if(this.clientDetail.groupId===item.id)
                        {
                            this.groupValue=item.id
                            this.getAccountGroupPerson()
                        }

                       /* if(item.id===this.clientWorkOrder.assigneeGroupId)
                        {
                            this.getWorkOrderAccountPerson()
                        }*/

                    })
                })
            },
            //获取负责人的下拉列表值
            getAccountPerson(){
                if(this.groupValue!=='')
                {
                    this.$http.get('/api/account/principal?groupId='+this.groupValue).then(res=>{
                        this.accountPerson.list=res.data.data
                        this.selectPersonList=res.data.data
                        this.selectCompanyPersonList=res.data.data
                    })
                }
                if(this.groupValue==='')
                {
                    this.$http.get('/api/account/principal?groupId=%20').then(res=>{
                        this.accountPerson.list=res.data.data
                        this.selectPersonList=res.data.data
                        this.selectCompanyPersonList=res.data.data
                    })
                }


            },
            getCompanyAccountPerson(){
                if(this.companyGroupValue!=='')
                {
                    this.$http.get('/api/account/principal?groupId='+this.companyGroupValue).then(res=>{
                        this.accountPerson.list=res.data.data
                        this.selectCompanyPersonList=res.data.data
                    })
                }
                if(this.companyGroupValue==='')
                {
                    this.$http.get('/api/account/principal?groupId=%20').then(res=>{
                        this.accountPerson.list=res.data.data
                        this.selectCompanyPersonList=res.data.data
                    })
                }
            },
            //获取负责组ID所对应的负责人
            getAccountGroupPerson(){
                if(this.clientDetail.groupId!=='')
                {
                    this.$http.get('/api/account/principal?groupId='+this.clientDetail.groupId).then(res=>{
                        this.accountPerson.list=res.data.data
                        this.selectPersonList=res.data.data
                        this.selectCompanyPersonList=res.data.data
                        this.accountPerson.list.find((item)=>{
                            if(item.id===this.clientDetail.principalId){
                                this.personValue=item.id
                            }


                        })
                    })
                }
                if(this.clientDetail.groupId==='')
                {
                    this.$http.get('/api/account/principal?groupId=%20').then(res=>{
                        this.accountPerson.list=res.data.data
                        this.selectPersonList=res.data.data
                        this.selectCompanyPersonList=res.data.data
                        this.accountPerson.list.find((item)=>{
                            if(item.id===this.clientDetail.principalId){
                                this.personValue=item.id
                            }


                        })
                    })
                }
            },
            getWorkOrderAccountPerson(){
                for (let i=0;i<this.workOrderList.length;i++)
                {
                    if(this.workOrderList[i].assigneeGroupId!=='')
                    {
                        this.$http.get('/api/account/principal?groupId='+this.workOrderList[i].assigneeGroupId).then(res=>{
                            if(res.data.data!==null)
                            {
                                res.data.data.forEach(item=>{
                                    this.workOrderPerson=item.name
                                })
                            }
                        })
                    }
                }



            },

            //获取客户对应的工单
            getWorkOrder(){
                this.workOrderList=[]
                this.$http.get('/api/order/page?num='+this.orderPageSize+'&page='+this.orderCurrentPage).then(res=>{
                    res.data.data.content.forEach(item=>{
                        if(item.clientId===this.$route.query.id)
                        {
                            this.workOrderList.push(item)
                            console.log(this.workOrderList)
                            this.workOrderList.forEach(items=>{
                                this.clientWorkOrder=items
                            })

                        }

                    })
                  console.log(this.workOrderList)
                    if (this.workOrderList.length ===0)
                    {
                        this.rightShow=0
                    }
                    else if(this.workOrderList.length  > 0)
                    {
                        this.rightShow=1
                    }
                })


            },
            editClient(){
                this.clientName=this.clientDetail.name
                if(this.clientDetail.grade==='NORMAL')
                    this.levelRadio='1'
                if(this.clientDetail.grade==='VIP')
                    this.levelRadio='2'
                this.inputPhone=this.clientDetail.tel
                this.inputEmail=this.clientDetail.mail
                this.describe=this.clientDetail.description
                if(this.clientDetail.companyId!=='')
                {
                    this.companyValue=this.clientDetail.companyId
                }
                if(this.clientDetail.groupId!=='')
                {
                    this.groupValue=this.clientDetail.groupId
                    this.$http.get('/api/account/principal?groupId='+this.clientDetail.groupId).then(res=>{
                        this.accountPerson.list=res.data.data
                        this.selectPersonList=res.data.data
                        this.selectCompanyPersonList=res.data.data
                        this.accountPerson.list.find((item)=>{
                            if(item.id===this.clientDetail.principalId){
                                this.personValue=item.id
                            }


                        })
                    })
                }
                if(this.clientDetail.groupId==='')
                {
                    this.groupValue=this.clientDetail.groupId
                    this.$http.get('/api/account/principal?groupId=%20').then(res=>{
                        this.accountPerson.list=res.data.data
                        this.selectPersonList=res.data.data
                        this.selectCompanyPersonList=res.data.data
                        this.accountPerson.list.find((item)=>{
                            if(item.id===this.clientDetail.principalId){
                                this.personValue=item.id
                            }


                        })
                    })
                }
                this.dialogFormVisible=true
            },
            //新增公司

            addClientCompany(){
                if(this.levelRadio==='1')
                    this.grade='NORMAL'
                if(this.levelRadio==='2')
                    this.grade='VIP'
                if(this.companyName==='')
                    this.$message('请输入公司名称')
                else {
                    this.$http.post('/api/client-company', {

                        contactPerson: this.contactPerson,
                        contactPersonMail: this.contactPersonMail,
                        contactPersonTel: this.contactPersonTel,
                        description: this.description,
                        groupId: this.companyGroupValue,
                        name: this.companyName,
                        principalId: this.companyPersonValue,
                        grade: this.grade,
                        mailSuffix: this.emailSuffix,
                    }).then(res => {
                        if(res.data.code==='0')
                        {
                            this.$message.success('添加公司成功')
                            this.addCompanySuccess=true
                        }
                        else{
                            this.$message.error(res.message)
                        }
                        this.getCompany()


                    });
                    this.groupSelect=''
                    this.personSelect=''
                    this.dialogFormVisible1=false

                }

            },
            addCompanyContinue(){
                if(this.levelRadio==='1')
                    this.grade='NORMAL'
                if(this.levelRadio==='2')
                    this.grade='VIP'
                if(this.companyName==='')
                    this.$message('请输入公司名称')
                else {
                    this.$http.post('/api/client-company', {
                        contactPerson: this.contactPerson,
                        contactPersonMail: this.contactPersonMail,
                        contactPersonTel: this.contactPersonTel,
                        description: this.description,
                        groupId: this.companyGroupValue,
                        name: this.companyName,
                        principalId: this.companyPersonValue,
                        grade: this.grade,
                        mailSuffix: this.emailSuffix,
                    }).then(res => {
                        if(res.data.code==='0')
                        {
                            this.$message.success('添加公司成功')
                            this.addCompanySuccess=true
                        }
                        else{
                            this.$message.error(res.message)
                        }
                        this.getCompany()
                    });
                    this.contactPerson=''
                    this.contactPersonMail=''
                    this.contactPersonTel=''
                    this.description=''
                    this.companyGroupValue=''
                    this.companyName=''
                    this.emailSuffix=''
                    this.levelRadio='1'
                    this.companyPersonValue=''
                    this.groupSelect=''
                    this.personSelect=''
                    this.dialogFormVisible1=true
                }

                /*   console.debug('post field response:', res);*/


            },
            calcAddCompany(){
                this.dialogFormVisible1=false
                this.groupSelect=''
                this.personSelect=''
            },
            dateFormat(time){
                let date=new Date(time);
                let year=date.getFullYear();
                /* 在日期格式中，月份是从0开始的，因此要加0
                 * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
                 * */
                let month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                let day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                let hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
                let minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
                let seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
                // 拼接
                return year+"-"+month+"-"+day+" "+hours+":"+minutes+":"+seconds;
            },
            shareClick(){
                  console.log(this.clientDetail.grade)
                if(this.clientDetail.grade==='NORMAL')
                    this.checkGrade='普通'
                if(this.clientDetail.grade==='VIP')
                    this.checkGrade='VIP'
               /* if(this.clientDetail.groupId!==''&&this.clientDetail.principalId!==''&&this.clientDetail.companyId!=='')
                {

                    this.copyUrl='向您分享了客户'+'\n'+this.clientDetail.name+"\xa0\xa0\xa0\xa0  "+this.clientDetail.company.name+"\xa0\xa0\xa0\xa0  " +this.clientDetail.tel+"\xa0\xa0\xa0\xa0 "+this.clientDetail.mail+"\xa0\xa0\xa0\xa0 "+this.checkGrade+"\xa0\xa0\xa0\xa0  "+this.clientDetail.group.name+"\xa0\xa0\xa0\xa0 "+this.clientDetail.principal.name+"\n"+window.location.href

                }
                else if(this.clientDetail.groupId!==''&&this.clientDetail.companyId!=='')
                {

                    this.copyUrl='向您分享了客户'+'\n'+this.clientDetail.name+"\xa0\xa0\xa0\xa0  "+this.clientDetail.company.name+"\xa0\xa0\xa0\xa0  " +this.clientDetail.tel+"\xa0\xa0\xa0\xa0 "+this.clientDetail.mail+"\xa0\xa0\xa0\xa0 "+this.checkGrade+"\xa0\xa0\xa0\xa0  "+this.clientDetail.group.name+"\n"+window.location.href

                }
                else if(this.clientDetail.principalId!==''&&this.clientDetail.companyId!=='')
                {

                    this.copyUrl='向您分享了客户'+'\n'+this.clientDetail.name+"\xa0\xa0\xa0\xa0  "+this.clientDetail.company.name+"\xa0\xa0\xa0\xa0  " +this.clientDetail.tel+"\xa0\xa0\xa0\xa0 "+this.clientDetail.mail+"\xa0\xa0\xa0\xa0 "+this.checkGrade+"\xa0\xa0\xa0\xa0  "+this.clientDetail.principal.name+"\n"+window.location.href

                }
                else if(this.clientDetail.companyId!=='')
                {

                    this.copyUrl='向您分享了客户'+'\n'+this.clientDetail.name+"\xa0\xa0\xa0\xa0  "+this.clientDetail.company.name+"\xa0\xa0\xa0\xa0  " +this.clientDetail.tel+"\xa0\xa0\xa0\xa0 "+this.clientDetail.mail+"\xa0\xa0\xa0\xa0 "+this.checkGrade+"\xa0\xa0\xa0\xa0  "+"\n"+window.location.href

                }
                else if(this.clientDetail.principalId!=='')
                {

                    this.copyUrl='向您分享了客户'+'\n'+this.clientDetail.name+"\xa0\xa0\xa0\xa0  " +this.clientDetail.tel+"\xa0\xa0\xa0\xa0 "+this.clientDetail.mail+"\xa0\xa0\xa0\xa0 "+this.checkGrade+"\xa0\xa0\xa0\xa0  "+this.clientDetail.principal.name+"\n"+window.location.href

                }*/
                /*else if(this.clientDetail.groupId!=='')
                {

                    this.copyUrl='向您分享了客户'+'\n'+this.clientDetail.name+"\xa0\xa0\xa0\xa0  " +this.clientDetail.tel+"\xa0\xa0\xa0\xa0 "+this.clientDetail.mail+"\xa0\xa0\xa0\xa0 "+this.checkGrade+"\xa0\xa0\xa0\xa0  "+this.clientDetail.group.name+"\n"+window.location.href

                }
                else {

                    this.copyUrl='向您分享了客户'+'\n'+this.clientDetail.name+"\xa0\xa0\xa0\xa0  " +this.clientDetail.tel+"\xa0\xa0\xa0\xa0 "+this.clientDetail.mail+"\xa0\xa0\xa0\xa0 "+this.checkGrade+"\xa0\xa0\xa0\xa0  "+"\n"+window.location.href

                }*/
                let companyName=''
                if (this.clientDetail.company){
                    companyName= this.clientDetail.company.name
                }
                if(this.clientDetail.companyId!==''&&this.clientDetail.groupId!==''&&this.clientDetail.principalId!==''&&this.clientDetail.tel!==''&&this.clientDetail.mail!=='')
                {
                    this.copyUrl1='姓名:'+" \xa0"+this.clientDetail.name+'\n'+'公司:'+" \xa0"+companyName+"\n"+'电话:'+" \xa0"+this.clientDetail.tel+"\n"+'邮箱:'+" \xa0"+this.clientDetail.mail+'\n'+'等级:'+" \xa0"+this.checkGrade+'\n'+'负责组:'+" \xa0 "+this.clientDetail.group.name+"\n"+'负责人:'+" \xa0 "+this.clientDetail.principal.name+'\n'+window.location.href+'\n'

                }

                else if(this.clientDetail.companyId!==''&&this.clientDetail.groupId!==''&&this.clientDetail.tel!==''&&this.clientDetail.mail!==''&&this.clientDetail.principalId==='')
                {
                    this.copyUrl1='姓名:'+" \xa0 "+this.clientDetail.name+'\n'+'公司:'+" \xa0 "+companyName+"\n"+'电话:'+" \xa0"+this.clientDetail.tel+"\n"+'邮箱:'+" \xa0"+this.clientDetail.mail+'\n'+'等级:'+" \xa0 "+this.checkGrade+"\n"+'负责组'+" \xa0 "+this.clientDetail.group.name+"\n"+window.location.href+'\n'

                }
                else if(this.clientDetail.companyId!==''&&this.clientDetail.principalId!==''&&this.clientDetail.tel!=='')
                {
                    this.copyUrl1='姓名:'+" \xa0 "+this.clientDetail.name+'\n'+'公司:'+" \xa0 "+companyName+"\n"+'电话:'+" \xa0 "+this.clientDetail.tel+'\n'+'等级:'+" \xa0 "+this.checkGrade+'\n'+'负责组:'+" \xa0 "+this.clientDetail.group.name+"\n"+'负责人:'+" \xa0 "+this.clientDetail.principal.name+"\n"+window.location.href+'\n'

                }
                else if(this.clientDetail.companyId!==''&&this.clientDetail.mail!==''&&this.clientDetail.principalId!==''){
                    this.copyUrl1='姓名:'+" \xa0"+this.clientDetail.name+'\n'+'公司:'+" \xa0"+companyName+"\n"+'邮箱:'+" \xa0"+this.clientDetail.mail+'\n'+'等级:'+" \xa0"+this.checkGrade+'\n'+'负责组:'+" \xa0 "+this.clientDetail.group.name+"\n"+'负责人:'+" \xa0 "+this.clientDetail.principal.name+'\n'+window.location.href+'\n'

                }
                else if(this.clientDetail.tel!==''&&this.clientDetail.mail!==''&&this.clientDetail.principalId!==''){
                    this.copyUrl1='姓名:'+" \xa0"+this.clientDetail.name+'\n'+'电话:'+" \xa0 "+this.clientDetail.tel+'\n'+'邮箱:'+" \xa0"+this.clientDetail.mail+'\n'+'等级:'+" \xa0"+this.checkGrade+'\n'+'负责组:'+" \xa0 "+this.clientDetail.group.name+"\n"+'负责人:'+" \xa0 "+this.clientDetail.principal.name+'\n'+window.location.href+'\n'

                }

                else if(this.clientDetail.companyId!==''&&this.clientDetail.tel!==''&&this.clientDetail.mail!=='')
                {
                    this.copyUrl1='姓名:'+" \xa0 "+this.clientDetail.name+'\n'+'公司:'+" \xa0 "+companyName+"\n"+'电话:'+" \xa0 "+this.clientDetail.tel+"\n"+'邮箱:'+" \xa0 "+this.clientDetail.mail+'\n'+'等级:'+" \xa0 "+this.checkGrade+"\n "+window.location.href+'\n'

                }
                else if(this.clientDetail.groupId!==''&&this.clientDetail.tel!==''&&this.clientDetail.mail!==''&&this.clientDetail.principalId==='')
                {
                    this.copyUrl1='姓名:'+" \xa0 "+this.clientDetail.name+'\n'+'电话:'+" \xa0 "+this.clientDetail.tel+"\n"+'邮箱:'+" \xa0 "+this.clientDetail.mail+'\n'+'等级:'+" \xa0 "+this.checkGrade+'负责组:'+" \xa0 "+this.clientDetail.group.name+"\n"+window.location.href+'\n'

                }
                else if(this.clientDetail.groupId!==''&&this.clientDetail.companyId!==''&&this.clientDetail.mail!==''&&this.clientDetail.principalId==='')
                {
                    this.copyUrl1='姓名:'+" \xa0 "+this.clientDetail.name+'\n'+'公司:'+" \xa0 "+companyName+"\n"+'邮箱:'+" \xa0 "+this.clientDetail.mail+'\n'+'等级:'+" \xa0 "+this.checkGrade+'负责组:'+" \xa0 "+this.clientDetail.group.name+"\n"+window.location.href+'\n'

                }
                else if(this.clientDetail.groupId!==''&&this.clientDetail.companyId!==''&&this.clientDetail.tel!==''&&this.clientDetail.principalId==='')
                {
                    this.copyUrl1='姓名:'+" \xa0 "+this.clientDetail.name+'\n'+'公司:'+" \xa0 "+companyName+"\n"+'电话:'+" \xa0 "+this.clientDetail.tel+"\n"+'等级:'+" \xa0 "+this.checkGrade+'负责组:'+" \xa0 "+this.clientDetail.group.name+"\n"+window.location.href+'\n'

                }
                else if(this.clientDetail.mail!==''&&this.clientDetail.principalId!=='')
                {
                    this.copyUrl1='姓名:'+" \xa0 "+this.clientDetail.name+'\n'+'邮箱:'+" \xa0 "+this.clientDetail.mail+'\n'+'等级:'+" \xa0 "+this.checkGrade+'负责组:'+" \xa0 "+this.clientDetail.group.name+'\n'+'负责人:'+" \xa0 "+this.clientDetail.principal.name+"\n"+window.location.href+'\n'

                }
                else if(this.clientDetail.principalId!==''&&this.clientDetail.tel!=='')
                {
                    this.copyUrl1='姓名:'+" \xa0 "+this.clientDetail.name+'\n'+'电话:'+this.clientDetail.tel+"\n"+"等级:"+this.checkGrade+"\n"+'负责组:'+" \xa0 "+this.clientDetail.group.name+'负责人:'+this.clientDetail.principal.name+"\n"+window.location.href+'\n'

                }
                else if(this.clientDetail.companyId!==''&&this.clientDetail.tel!=='')
                {
                    this.copyUrl1='姓名:'+" \xa0 "+this.clientDetail.name+'\n'+'电话:'+" \xa0 "+this.clientDetail.tel+"\n"+"等级:"+" \xa0 "+this.checkGrade+"\n"+"\n"+window.location.href+'\n'

                }
                else if(this.clientDetail.companyId!==''&&this.clientDetail.mail!=='')
                {
                    this.copyUrl1='姓名:'+" \xa0 "+this.clientDetail.name+'\n'+'邮箱:'+" \xa0 "+this.clientDetail.mail+"\n"+"等级:"+" \xa0 "+this.checkGrade+"\n"+window.location.href+'\n'

                }
                else if(this.clientDetail.principalId!==''&&this.clientDetail.companyId!=='')
                {
                    this.copyUrl1='姓名:'+" \xa0 "+this.clientDetail.name+'\n'+'公司名称:'+" \xa0 "+this.clientDetail.company.name+"\n"+"等级:"+this.checkGrade+"\n"+'负责组:'+" \xa0 "+this.clientDetail.group.name+'\n'+'负责人:'+this.clientDetail.principal.name+"\n"+window.location.href+'\n'

                }
                else if(this.clientDetail.tel!==''&&this.clientDetail.mail!=='')
                {
                    this.copyUrl1='姓名:'+" \xa0 "+this.clientDetail.name+'\n'+'电话:'+" \xa0 "+this.clientDetail.tel+"\n"+'邮箱:'+" \xa0 "+this.clientDetail.mail+'\n'+'等级:'+" \xa0 "+this.checkGrade+"\n"+window.location.href+'\n'

                }

                else if(this.clientDetail.groupId!==''&&this.clientDetail.tel!==''&&this.clientDetail.principalId==='')
                {
                    this.copyUrl1='姓名:'+" \xa0 "+this.clientDetail.name+'\n'+'电话:'+" \xa0 "+this.clientDetail.tel+"\n"+'等级:'+" \xa0 "+this.checkGrade+'负责组:'+" \xa0 "+this.clientDetail.group.name+"\n"+window.location.href+'\n'

                }
                else if(this.clientDetail.groupId!==''&&this.clientDetail.mail!==''&&this.clientDetail.principalId==='')
                {
                    this.copyUrl1='姓名:'+" \xa0 "+this.clientDetail.name+'\n'+'邮箱:'+" \xa0 "+this.clientDetail.mail+'\n'+'等级:'+" \xa0 "+this.checkGrade+'负责组:'+" \xa0 "+this.clientDetail.group.name+"\n"+window.location.href+'\n'

                }

                else if(this.clientDetail.tel!=='')
                {
                    this.copyUrl1='姓名:'+" \xa0 "+this.clientDetail.name+'\n'+'电话:'+" \xa0 "+this.clientDetail.tel+'\n'+'等级:'+" \xa0 "+this.checkGrade+"\n"+window.location.href+'\n'

                }
                else if(this.clientDetail.mail!=='')
                {
                    this.copyUrl1='姓名:'+" \xa0 "+this.clientDetail.name+'\n'+'邮箱:'+" \xa0 "+this.clientDetail.mail+'\n'+'等级:'+" \xa0 "+this.checkGrade+"\n"+window.location.href+'\n'

                }
                else if(this.clientDetail.groupId!==''&&this.clientDetail.principalId==='')
                {
                    this.copyUrl1='姓名:'+" \xa0 "+this.clientDetail.name+'\n'+'等级:'+" \xa0 "+this.checkGrade+'\n'+'负责组'+" \xa0 "+this.clientDetail.group.name+"\n"+window.location.href+'\n'
                }
                else if(this.clientDetail.principalId!=='')
                {
                    this.copyUrl1='姓名:'+" \xa0 "+this.clientDetail.name+'\n'+'等级:'+" \xa0 "+this.checkGrade+'\n'+'负责组:'+" \xa0 "+this.clientDetail.group.name+'\n'+'负责人:'+" \xa0 "+this.clientDetail.principal.name+"\n"+window.location.href+'\n'
                }
                else if(this.clientDetail.companyId!=='')
                {
                    this.copyUrl1='姓名:'+" \xa0 "+this.clientDetail.name+'\n'+'公司:'+" \xa0 "+this.clientDetail.company.name+'\n'+'等级:'+" \xa0 "+this.checkGrade+"\n"+window.location.href+'\n'
                }
                else
                {
                    this.copyUrl1='姓名:'+" \xa0 "+this.clientDetail.name+"\n"+'等级:'+" \xa0 "+this.checkGrade+"\n"+window.location.href+'\n'

                }
                this.copyUrl='向您分享了客户'+'\n'+'\n'+this.copyUrl1
                






            },
            onCopy() {
                this.$message.success('客户内容已复制，请发送给相关同事')
            },
            emailClick(){
                const reg= /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
                if(this.inputEmail!=='')
                {
                    if(!reg.test(this.inputEmail))
                        this.$message('请输入有效的邮箱')
                }

            },
            phoneClick(){
                const phone=/^[1][3,4,5,7,8][0-9]{9}$/
                if(this.inputPhone!=='')
                {
                    if(!phone.test(this.inputPhone))
                        this.$message('请输入有效的电话号码')
                }

            },
            emaiBblurClick(){

                const reg= /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
                if(this.contactPersonMail!=='')
                {
                    if(!reg.test(this.contactPersonMail))
                        this.$message('请输入有效的邮箱')
                }

            },
            phoneBlurClick(){
                const phone=/^[1][3,4,5,7,8][0-9]{9}$/
                if(this.contactPersonTel!=='')
                {
                    if(!phone.test(this.contactPersonTel))
                        this.$message('请输入有效的电话号码')
                }

            },
            loadMore(){
                this.CompanyPageSize+=10
                this.getCompany()
            },
            //获取搜索公司的下拉值
            changeSelectCompany(value){
                if(value!=='')
                {
                    let selectCompany=[]
                    this. company.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectCompany.push(item)
                        }
                    })
                    this.selectCompanyList=selectCompany

                }
                else
                {
                    this.selectCompanyList=this.company.list
                }

            },

            //获取受理组的搜索下拉
            changeSelectGroup(value){
                if(value!=='')
                {
                    let selectCompany=[]
                    this. accountGroup.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectCompany.push(item)
                        }
                    })
                    this.selectGroupList=selectCompany

                }
                else
                {
                    this.selectGroupList=this.accountGroup.list
                }

            },
            changeCompanySelectGroup(value){
                if(value!=='')
                {
                    let selectCompany=[]
                    this. accountGroup.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectCompany.push(item)
                        }
                    })
                    this.selectCompanyGroupList=selectCompany

                }
                else
                {
                    this.selectCompanyGroupList=this.accountGroup.list
                }

            },

            //获取受理人的搜索下拉
            changeSelectPerson(value){
                if(value!=='')
                {
                    let selectPerson=[]
                    this.accountPerson.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectPerson.push(item)
                        }
                    })
                    this.selectPersonList=selectPerson

                }
                else
                {
                    this.selectPersonList=this.accountPerson.list
                }
            },
            changeCompanySelectPerson(value){
                if(value!=='')
                {
                    let selectPerson=[]
                    this.accountPerson.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectPerson.push(item)
                        }
                    })
                    this.selectCompanyPersonList=selectPerson

                }
                else
                {
                    this.selectCompanyPersonList=this.accountPerson.list
                }
            }

        },
        activated() {
            console.log('aaaa')
        },
        deactivated() {
            console.log('bbbb')
        },
        watch:{
            getCustomerDetail:function (a) {
                console.log(a)
            }
        }

    }
</script>

<style lang="less">
@import "../../../assets/less/customlist/customerdetail/customerdetail";
.emailCompanyNum1{
    width: 100px;
    overflow: hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
}
</style>